import { FormControlLabel, Checkbox, Grid } from '@material-ui/core';
import React from 'react';

export const MyCheckBox = ({ checkBoxState, checkBoxOnChange, children }) => {
    return (
        <div style={{ display: 'flex', marginBottom: 40 }}>
            <div>
                <FormControlLabel label="" control={<Checkbox checked={checkBoxState} onChange={checkBoxOnChange} />} />
            </div>
            <div>{children}</div>
        </div>
    );
};
